import {AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {BaseComponent} from '../../base/base.component';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {QueryRef} from 'apollo-angular';
import {Subscription} from 'rxjs';

import {
  DashboardHome,
  GetAllIdeasGQL,
  GetAllIdeasQuery,
  GetCountriesGQL,
  GetDashboardHomeGQL,
  GetDashboardHomeQuery,
  GetIdeasSearchGQL,
  GetIdeasSearchQuery,
  GetNewsGQL,
  GetNewsQuery,
  GetUnitiesByCountryGQL,
  SearchIdeaInput,
} from '../../../generated/graphql';
import {EventBusService, Events} from '../../service/event-bus.service';
import {UserService} from "../../service/user.service";
import { GetEmployeeByReQuery } from 'src/app/model/employee';
import { GetEmployeeByReGQL } from 'graphql/employee/employee.definition';
import { GetWalletByEmployeeIdQuery } from 'src/app/model/wallet';
import { GetWalletByEmployeeIdGQL } from 'graphql/wallet/wallet.definition';


declare var $: any;

const HOME_FILTER_KEY = 'clic.filter.home.v1';

// estado aplicado da Home: RE de "minhas ideias" + filtro de "ideias implementadas"
interface IHomeFilter {
  re?: string;
  countryId?: string;
  unityId?: string;
  keyword?: string;
}

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent extends BaseComponent implements OnInit, OnDestroy {

  eventbusSub: Subscription;
  filter: number;
  newIdea = 0;
  approvedIdeas = 0;
  awardeds: any[] = [];
  financialFeedback = 0;
  modelIdeaFilter: SearchIdeaInput = new SearchIdeaInput();
  modelEmployee: {re: string} = {re: '' };
  // só o que foi efetivamente aplicado (busca por RE / filtro de implementadas) é salvo
  private homeFilter: IHomeFilter = {};
  re: string;
  isEmployee: boolean;

  getWalletByEmployeeIdQuery: QueryRef<GetWalletByEmployeeIdQuery>;
  points: number;

  ideasQuery: QueryRef<GetIdeasSearchQuery>;
  ideas: any;
  countries: any;
  unities: any;

  allIdeasQuery: QueryRef<GetAllIdeasQuery>;
  allIdeas: any;
  allIdeasKaizen: any;
  isSearchClic = false;
  showKaizenIdeaButton: boolean;
  allNewsQuery: QueryRef<GetNewsQuery>;
  allNews: any;
  kaizen: boolean;

  getEmployeeByReQuery: QueryRef<GetEmployeeByReQuery>;

  options = {
    decimalPlaces: 2,
    separator: '.',
    decimal: ',',
  };
  homeDashQuery: QueryRef<GetDashboardHomeQuery>;
  homeDash: DashboardHome = new DashboardHome();
  homeDashNumbers: DashboardHome = {
    news: 0,
    approves: 0,
    finances: 0,
    energy: 0,
    machineValue: 0,
    manValue: 0,
    waste: 0,
    water: 0
  };

  slideConfig = {
    slidesToShow: 2.3,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  slideConfigCentered = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    infinite: true,
    centerMode: true,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: false,
          centerMode: false
        }
      }
    ]
  };

  @ViewChild('seekRecognition') seekRecognition: ElementRef;
  condition: any;

  @HostListener('window:scroll', ['$event'])
  onWindowScroll($event) {


    if (this.scrollCalculation(this.seekRecognition)) {
      $('#seekRecognition').addClass('active');
    }
  }

  scrollCalculation(rects): boolean {
    const rect = rects.nativeElement.getBoundingClientRect();
    const elemTop = rect.top;
    const elemBottom = rect.bottom;
    if (window.innerWidth < 980) {
      return true;
    } else {
      return (elemTop >= 0) && (elemBottom <= window.innerHeight);
    }
  }

  constructor(public router: Router,
              public translate: TranslateService,
              private eventbus: EventBusService,
              private getAllIdeasGQL: GetAllIdeasGQL,
              private getIdeasSearchGQL: GetIdeasSearchGQL,
              private getDashboardHomeGQL: GetDashboardHomeGQL,
              private getCountriesGQL: GetCountriesGQL,
              private getEmployeeByReGQL: GetEmployeeByReGQL,
              public userService: UserService,
              private getNewsGQL: GetNewsGQL,
              private getUnitiesByCountryGQL: GetUnitiesByCountryGQL,
              private getWalletByEmployeeIdGQL: GetWalletByEmployeeIdGQL,
  ) {
    super(router, translate);
  }

  ngOnInit(): void {
    this.eventbusSub = this.eventbus.on(Events.isUpdateIdea, ((data) => this.handlerUpdateIdeaList(data)));

    // restaura o filtro salvo (ao voltar do idea-detail) ANTES da 1ª query de implementadas
    const saved: IHomeFilter = this.getFilterSession(HOME_FILTER_KEY);
    if (saved) {
      this.homeFilter = saved;
      this.modelIdeaFilter.countryId = saved.countryId;
      this.modelIdeaFilter.keyword = saved.keyword;
      if (!this.isNullOrUndefined(saved.countryId)) {
        // unidades do país salvo primeiro; a unidade só é aplicada ao select depois que elas chegam
        // (handlerCountry() não é usado aqui porque zeraria a unidade)
        this.loadUnities(saved.countryId, saved.unityId);
      }
    }

    // a query já parte do filtro salvo (inclusive a unidade), independente das opções do select
    this.ideasQuery = this.getIdeasSearchGQL.watch({input: {...this.modelIdeaFilter, unityId: saved?.unityId}});
    this.ideasQuery.valueChanges.subscribe(({data}) => {
      this.ideas = data.getIdeasSearch.filter(a => !this.isNullOrUndefined(a.challengeLanguage)
        && a.challengeLanguage.includes(this.translate.currentLang));
      setTimeout(() => {
        $(() => {
          $('#slick-slider-implement').slick(this.slideConfig);
        });
      }, 500);
    });

    this.allNewsQuery = this.getNewsGQL.watch();
    this.allNewsQuery.valueChanges.subscribe(({data}) => {
      this.allNews = data.getNews;
      setTimeout(() => {
        $(() => {
          $('#slick-slider-news').slick(this.slideConfigCentered);
        });
      }, 500);
    });

    this.getCountriesGQL.watch().valueChanges.subscribe(({data}) => {
      this.countries = data.getCountries;
    });

    this.homeDashQuery = this.getDashboardHomeGQL.watch();

    this.homeDashQuery.valueChanges.subscribe(({data}) => {
      this.homeDash = data.getDashboardHome as DashboardHome;
    });

    this.isEmployee = localStorage.getItem('re') ? true : false;

    // Cadastro Kaizen: só admin ou participante de comitê Kaizen ('kaizen' é string no localStorage).
    const isAdmin = localStorage.getItem('role') === 'admin';
    const isKaizenMember = localStorage.getItem('kaizen') === 'true';
    this.showKaizenIdeaButton = isAdmin || isKaizenMember;

    // "minhas ideias": refaz a mesma busca do usuário com o RE salvo (lista + carrosséis)
    if (!this.isNullOrUndefined(saved?.re)) {
      this.modelEmployee.re = saved.re;
      this.actionFilterIdeaAll();
    }
  }

  private saveHomeFilter() {
    this.setFilterSession(HOME_FILTER_KEY, this.homeFilter);
  }

  ngOnDestroy(): void {
    this.eventbusSub.unsubscribe();
  }

  handlerUpdateIdeaList(d: any): void {
    this.allIdeasQuery.refetch(this.modelEmployee);
    this.actionFilterIdeaAll();
  }

  validateFilter() {
    return {
      keyword: this.modelIdeaFilter.keyword,
      unityId: this.modelIdeaFilter.unityId === undefined ? '' : this.modelIdeaFilter.unityId,
    };
  }

  async actionFilterIdeaAll() {
    if (this.isNullOrUndefined(this.modelEmployee.re)) {
      this.showMessage(this.translate.instant('attention'), this.translate.instant('ReRequireMsg'), 'warning');
      return;
    }

    this.homeFilter.re = this.modelEmployee.re;
    this.saveHomeFilter();

    this.allIdeasQuery = this.getAllIdeasGQL.watch({keyword: this.modelEmployee.re});
    this.allIdeasQuery.valueChanges.subscribe(({data}) => {
      this.allIdeas = data.getAllIdeas
      const ideas = this.allIdeas.filter(item => !item.code.includes('K-'));
      const ideasKaizen = this.allIdeas.filter(item => item.code.includes('K-'));

      if(this.allIdeas.length > 0) {
        this.allIdeas = ideas
        this.allIdeasKaizen = ideasKaizen
        this.isSearchClic = true;
        return
      }

      this.isSearchClic = false;
    });

    const elKaizen = $('#slick-slider-ideal-kaizen');
    const el = $('#slick-slider-ideal');

    elKaizen.css({opacity: 0, visibility: 'hidden'}).slick('unslick');
    el.css({opacity: 0, visibility: 'hidden'}).slick('unslick');

    setTimeout(() => {
      $(() => {
          $("#slick-slider-ideal-kaizen").slick(this.slideConfig).css({opacity: 1, visibility: 'visible'});
          $("#slick-slider-ideal").slick(this.slideConfig).css({opacity: 1, visibility: 'visible'});
      });
    }, 1000);

    this.modelEmployee.re = this.modelEmployee.re;

    // this.getEmployeeByRe()
  }

  getEmployeeByRe() {
    this.getEmployeeByReQuery = this.getEmployeeByReGQL.watch(this.modelEmployee);

    this.getEmployeeByReQuery.valueChanges.subscribe({
      next: ({data}) => {
        this.getWallet(data.getEmployeeRe?.id)
      },
      error: (erro) => {
        this.points = null
        // this.showMessage(this.translate.instant('attention'), this.translate.instant('ReError'), 'warning');
      }
    });
  }

  getWallet(id: string) {
    this.getWalletByEmployeeIdQuery = this.getWalletByEmployeeIdGQL.watch({employeeId: id})
    this.getWalletByEmployeeIdQuery.valueChanges.subscribe({
      next: ({data}) => {
        this.points = data?.getWalletByEmployeeId?.value
      },
      error: () => {
        this.points = null
        this.showMessage(this.translate.instant('attention'), this.translate.instant('WalletError'), 'warning');
      }
    })
  }

  actionFilterIdea() {
    this.homeFilter.countryId = this.modelIdeaFilter.countryId;
    this.homeFilter.unityId = this.modelIdeaFilter.unityId;
    this.homeFilter.keyword = this.modelIdeaFilter.keyword;
    this.saveHomeFilter();

    const el = $('#slick-slider-implement');
    el.css({opacity: 0, visibility: 'hidden'}).slick('unslick');
    this.ideasQuery.refetch({input: this.modelIdeaFilter});
    setTimeout(() => {
      $(() => {
        $('#slick-slider-implement').slick(this.slideConfig).css({opacity: 1, visibility: 'visible'});
      });
    }, 500);
  }

  handlerCountry($event = '') {
    this.modelIdeaFilter.unityId = undefined;
    this.loadUnities($event);
  }

  // carrega as unidades do país; se informado, aplica unityId só depois que as opções chegam
  private loadUnities(countryId: string, unityId?: string) {
    let pendingUnityId = unityId;
    this.getUnitiesByCountryGQL.watch({id: countryId}).valueChanges.subscribe(({data}) => {
      this.unities = data.getUnitiesByCountry;
      if (pendingUnityId !== undefined) {
        this.modelIdeaFilter.unityId = pendingUnityId;
        pendingUnityId = undefined;
      }
    });
  }

  onNavigateRouter(s: string) {
    this.router.navigate([s]);
  }

  onNavScroll(str: string) {
    $('html, body').animate({scrollTop: $('#' + str).offset().top}, 1000);
  }

  getAwardeds() {
    this.awardeds = this.ideas?.filter(a => a.status === 'awarded');
    return this.awardeds;
  }
}


